/* eslint-disable @typescript-eslint/no-explicit-any */
import { Action, Store } from 'redux'
import { ThunkAction } from 'redux-thunk'
import {
  ASSIGN_VIEW_REPORT_PERMISSION_URL,
  CREATE_AUTOGENERATE_EXAM_QUESTION,
  EXAM_CREATION_DETAILS_URL,
  EXAM_GRADE_URL,
  EXAM_LIST_URL,
  EXAM_TYPE_URL,
  GET_EXAM_BATCHES_URL,
  QUESTION_WISE_STUDENT_LIST_URL,
  REASONING_TYPE_URL,
  STUDENT_LIST_URL,
} from '../../service/apiEndPoints'
import { apiCall, METHOD } from '../../service/baseApiCall'
import { showErrorToastMessage, successToast } from '../../util/utils'
import { ReasoninTypePayload } from '../Actions'
import {
  ASSIGN_EXAM,
  ASSIGN_VIEW_EXAM_REPORT_PERMISSION,
  CREATE_AUTOGENERATE_EXAM_QUESTIONS,
  EXAM_CREATE,
  EXAM_GRADE_LIST,
  EXAM_LIST,
  EXAM_TYPE,
  GET_EXAM_BATCH,
  GET_EXAM_CREATION_DETAILS,
  REASONING_TYPE_LIST,
  SME_CREATE_EXAM_QP,
  STUDENT_DATA,
  STUDENT_DATA_DOWNLOAD_EXCEL,
  STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL,
  UPDATE_EXAM,
} from '../constants/action-types'

// ************** EXAM_LIST ******************

export const examList =
  (
    showToast = false,
    search?: string | null,
    page?: number,
    status?: string,
    examination_type?: any,
    duration_max?: any,
    ordering?: any,
    batchId?: number,
    isReadyExam?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      examListInit(
        showToast,
        search,
        page,
        status,
        examination_type,
        duration_max,
        ordering,
        batchId,
        isReadyExam
      )
    )
  }

export const examListInit =
  (
    showToast: boolean,
    search?: string | null,
    page?: number,
    status?: string,
    examination_type?: string,
    duration_max?: any,
    ordering?: string,
    batchId?: number,
    isReadyExam?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    const params: any = new URLSearchParams()
    if (search) params.append('search', search)
    if (page) params.append('page', page)
    if (status) params.append('status', status)
    if (status && !isReadyExam) params.append('status', 'ASSIGNED')
    if (examination_type) params.append('examination_type', examination_type)
    if (duration_max || duration_max == 0)
      params.append('duration_max', duration_max)
    if (ordering) params.append('ordering', ordering)
    if (batchId) params.append('batch', batchId)

    dispatch({
      type: EXAM_LIST.EXAM_LIST_INITLIZATION,
    })
    apiCall(
      EXAM_LIST_URL,
      (res: any) => dispatch(examListSuccess(res)),
      (err: any) => {
        dispatch(examListError(err))
      },
      {
        params: params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const examListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.EXAM_LIST_SUCCESS,
      payload: res.data,
    })
  }

export const examListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.EXAM_LIST_ERORR,
      payload: err.message,
    })
  }

// ************** CREATE EXAM ******************

export const examCreate =
  (
    showToast = false,
    payload,
    _hanldeRedirect: (args) => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      examCreateInit(showToast, payload, _hanldeRedirect, _handleFailure)
    )
  }

export const examCreateInit =
  (
    showToast: boolean,
    payload,
    _hanldeRedirect: (args) => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_CREATE.EXAM_CREATE_INITLIZATION,
    })
    apiCall(
      EXAM_LIST_URL,
      (res: any) => {
        dispatch(examCreateSuccess(res, _hanldeRedirect, payload))
      },
      (err: any) => {
        dispatch(examCreateError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: showToast }
    )
  }

export const examCreateSuccess =
  (
    res: any,
    _hanldeRedirect,
    payload
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_CREATE.EXAM_CREATE_SUCCESS,
      payload: res,
    })
    _hanldeRedirect({
      ...res,
      data: {
        ...(res?.data || {}),
        assignToSME: payload?.question_paper_mode === 'ATS',
      },
    })
  }

export const examCreateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_CREATE.EXAM_CREATE_ERORR,
      payload: err.message,
    })
    _handleFailure()
    showErrorToastMessage(err?.data?.message?.due_date?.[0])
  }

// ************** UPDATE EXAM ******************

export const updateExam =
  (
    showToast = false,
    payload,
    _hanldeRedirect: () => void,
    _handleFailure: (error: any) => void,
    examId: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      updateExamInit(
        showToast,
        payload,
        _hanldeRedirect,
        _handleFailure,
        examId
      )
    )
  }

export const updateExamInit =
  (
    showToast: boolean,
    payload,
    _hanldeRedirect: () => void,
    _handleFailure: (error: any) => void,
    examId: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_EXAM.UPDATE_EXAM_INITLIZATION,
    })
    apiCall(
      `${EXAM_LIST_URL}/${examId}`,
      (res: any) => {
        dispatch(updateExamSuccess(res, _hanldeRedirect))
      },
      (err: any) => {
        dispatch(updateExamError(err, _handleFailure))
      },
      payload,
      METHOD.PUT,
      { showToast: showToast }
    )
  }

export const updateExamSuccess =
  (
    res: any,
    _hanldeRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_EXAM.UPDATE_EXAM_SUCCESS,
      payload: res,
    })
    _hanldeRedirect()
  }

export const updateExamError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_EXAM.UPDATE_EXAM_ERROR,
      payload: err.message,
    })
    _handleFailure(err)
  }

// ************** EXAM_TYPE_LIST ******************

export const examTypeList =
  (
    showToast = false,
    params?: URLSearchParams
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(examTypeListInit(showToast, params))
  }

export const examTypeListInit =
  (
    showToast: boolean,
    params?: URLSearchParams
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_TYPE.EXAM_TYPE_INITLIZATION,
    })
    apiCall(
      EXAM_TYPE_URL,
      (res: any) => dispatch(examTypeListSuccess(res)),
      (err: any) => {
        dispatch(examTypeListError(err))
      },
      { params },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const examTypeListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_TYPE.EXAM_TYPE_SUCCESS,
      payload: res,
    })
  }

export const examTypeListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_TYPE.EXAM_TYPE_ERORR,
      payload: err.message,
    })
  }

// ************** EXAM_GRADE_LIST ******************

export const examGradeList =
  (showToast = false): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(examGradeListInit(showToast))
  }

export const examGradeListInit =
  (showToast: boolean): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_GRADE_LIST.EXAM_GRADE_LIST_INITLIZATION,
    })
    apiCall(
      EXAM_GRADE_URL,
      (res: any) => dispatch(examGradeListSuccess(res)),
      (err: any) => {
        dispatch(examGradeListError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const examGradeListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_GRADE_LIST.EXAM_GRADE_LIST_SUCCESS,
      payload: res,
    })
  }

export const examGradeListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_GRADE_LIST.EXAM_GRADE_LIST_ERORR,
      payload: err.message,
    })
  }

// Reasoning Type List
export const reasoningTypeList =
  (showToast = false): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(reasoningTypeListInit(showToast))
  }

export const reasoningTypeListInit =
  (showToast: boolean): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: REASONING_TYPE_LIST.REASONING_TYPE_LIST_INITLIZATION,
    })
    apiCall(
      REASONING_TYPE_URL,
      (res: any) => dispatch(reasoningTypeListSuccess(res)),
      (err: any) => {
        dispatch(reasoningTypeListError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const reasoningTypeListSuccess =
  (
    res: ReasoninTypePayload
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: REASONING_TYPE_LIST.REASONING_TYPE_LIST_SUCCESS,
      payload: res,
    })
  }

export const reasoningTypeListError =
  (
    err: ReasoninTypePayload
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: REASONING_TYPE_LIST.REASONING_TYPE_LIST_ERORR,
      payload: err.message,
    })
  }
// ************** ONGOING EXAM_LIST ******************
export const onGoingExamList =
  (
    showToast = false,
    search?: string | null,
    page?: number,
    status?: string,
    examination_type?: any,
    duration_max?: any,
    ordering?: any,
    batchId?: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      onGoingExamListInit(
        showToast,
        search,
        page,
        status,
        examination_type,
        duration_max,
        ordering,
        batchId
      )
    )
  }

export const onGoingExamListInit =
  (
    showToast: boolean,
    search?: string | null,
    page?: number,
    status?: string,
    examination_type?: string,
    duration_max?: any,
    ordering?: string,
    batchId?: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.ONGOING_EXAM_LIST_INITLIZATION,
    })
    apiCall(
      EXAM_LIST_URL,
      (res: any) => dispatch(onGoingExamListSuccess(res?.data)),
      (err: any) => {
        dispatch(onGoingExamListError(err))
      },
      {
        params: {
          search,
          page,
          status,
          examination_type,
          duration_max,
          ordering,
          batchId: batchId && batchId > -1 ? batchId : undefined,
        },
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const onGoingExamListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.ONGOING_EXAM_LIST_SUCCESS,
      payload: res,
    })
  }

export const onGoingExamListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.ONGOING_EXAM_LIST_FAIL,
      payload: err.message,
    })
  }
// ************** COMPLETED EXAM_LIST ******************

export const completedExamList =
  (
    showToast = false,
    search?: string | null,
    page?: number,
    status?: string,
    examination_type?: any,
    duration_max?: any,
    ordering?: any,
    batchId?: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      completedExamListInit(
        showToast,
        search,
        page,
        status,
        examination_type,
        duration_max,
        ordering,
        batchId
      )
    )
  }

export const completedExamListInit =
  (
    showToast: boolean,
    search?: string | null,
    page?: number,
    status?: string,
    examination_type?: string,
    duration_max?: any,
    ordering?: any,
    batchId?: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.COMPLETED_EXAM_LIST_INITLIZATION,
    })
    const params: any = new URLSearchParams()
    if (search) params.append('search', search)
    if (page) params.append('page', page)
    if (status) params.append('status', status)
    if (status) params.append('status', 'EVALUATING_RESULT')
    if (examination_type) params.append('examination_type', examination_type)
    if (duration_max || duration_max == 0)
      params.append('duration_max', duration_max)
    if (ordering) params.append('ordering', ordering)
    if (batchId) params.append('batch', batchId)
    apiCall(
      EXAM_LIST_URL,
      (res: any) => dispatch(completedExamListSuccess(res?.data)),
      (err: any) => {
        dispatch(completedExamListError(err))
      },
      {
        params: params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const completedExamListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.COMPLETED_EXAM_LIST_SUCCESS,
      payload: res,
    })
  }

export const completedExamListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.COMPLETED_EXAM_LIST_FAIL,
      payload: err.message,
    })
  }

//**************** GET EXAM BY ID  ***********************
export const examByIdList =
  (
    showToast = false,
    id: string | undefined
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(examByIdInit(showToast, id))
  }

export const examByIdInit =
  (
    showToast: boolean,
    id: string | undefined
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.EXAM_LIST_BY_ID_INITIALIZATION,
    })
    apiCall(
      `/api/exam-v2/${id}`,
      (res: any) => dispatch(examListByIdSuccess(res?.data)),
      (err: any) => {
        dispatch(examListByIdError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const examListByIdSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.EXAM_LIST_BY_ID_SUCCESS,
      payload: res,
    })
  }

export const examListByIdError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.EXAM_LIST_BY_ID_ERROR,
      payload: err.message,
    })
  }

// ************** STUDENT LIST FROM EXAM ******************

export const studentData =
  (
    showToast: boolean,
    id: string | undefined,
    page: number,
    search: string | null,
    ordering: Record<string, string> | null,
    attempt_status: string | null,
    sorted: any,
    examStatus?: string
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      studentDataInit(
        showToast,
        id,
        page,
        search,
        ordering,
        attempt_status,
        sorted,
        examStatus
      )
    )
  }

export const studentDataInit =
  (
    showToast: boolean,
    id: string | undefined,
    page: number,
    search: string | null,
    ordering: Record<string, string> | null,
    attempt_status: string | null,
    sorted?: any,
    examStatus?: string
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    const params = new URLSearchParams()
    page && params.append('page', page?.toString())
    params.append('all_sorted_records', sorted)

    ordering &&
      ordering.student_firstname &&
      params.append('ordering', ordering.student_firstname)

    search && params.append('search', search)
    ordering && ordering.rank && params.append('ordering', ordering.rank)
    if (examStatus === 'U') {
      params?.append('attempt_status', examStatus)
    } else {
      examStatus && params?.append('examinee_status', examStatus)
    }
    dispatch({
      type: STUDENT_DATA.STUDENT_DATA_INITIALIZATION,
    })
    apiCall(
      STUDENT_LIST_URL + `${id}/report`,
      (res: any) => dispatch(studentDataSuccess(res)),
      (err: any) => {
        dispatch(studentDataError(err))
      },
      {
        params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const studentDataSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: STUDENT_DATA.STUDENT_DATA_SUCCESS,
      payload: res.data,
    })
  }

export const studentDataError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: STUDENT_DATA.STUDENT_DATA_ERROR,
      payload: err.message,
    })
  }

// ************** TAB KEY FOR EXAM ******************

export const examTabKeySuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_LIST.EXAM_TAB_KEY_SUCCESS,
      payload: res,
    })
  }

// ************** CREATE QUESTION PAPER  FOR AUTOGENERATED MODE ******************

export const autogenerateExamQuestions =
  <T extends object>(
    payload: T,
    handleSuccess: () => void,
    handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: CREATE_AUTOGENERATE_EXAM_QUESTIONS.CREATE_AUTOGENERATE_EXAM_QUESTIONS_INITLIZATION,
    })
    apiCall(
      CREATE_AUTOGENERATE_EXAM_QUESTION,
      (res: any) => {
        dispatch({
          type: CREATE_AUTOGENERATE_EXAM_QUESTIONS.CREATE_AUTOGENERATE_EXAM_QUESTIONS_SUCCESS,
          payload: res.data,
        })
        handleSuccess()
      },
      (err: any) => {
        dispatch({
          type: CREATE_AUTOGENERATE_EXAM_QUESTIONS.CREATE_AUTOGENERATE_EXAM_QUESTIONS_ERROR,
        })
        showErrorToastMessage(
          err?.message?.distribution || 'Something went wrong'
        )
        handleFailure()
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

// ************** Exam Creation Details ******************

export const getExamCreationDetails =
  (examId: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_EXAM_CREATION_DETAILS.GET_EXAM_CREATION_DETAILS_INITIALIZATION,
    })
    apiCall(
      `${EXAM_CREATION_DETAILS_URL}/${examId}`,
      (res: any) => {
        dispatch({
          type: GET_EXAM_CREATION_DETAILS.GET_EXAM_CREATION_DETAILS_SUCCESS,
          payload: res.data,
        })
      },
      () => {
        dispatch({
          type: GET_EXAM_CREATION_DETAILS.GET_EXAM_CREATION_DETAILS_ERROR,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }

// ************** Create Exam Question Paper(From SME Login) ******************

export const createQuestionPaperForExam =
  <T extends object>(
    payload: T,
    examId: number,
    onSuccess: () => void,
    onError: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SME_CREATE_EXAM_QP.SME_CREATE_EXAM_QP_INITIALIZATION,
    })
    apiCall(
      `${EXAM_LIST_URL}/${examId}`,
      (res: any) => {
        dispatch({
          type: SME_CREATE_EXAM_QP.SME_CREATE_EXAM_QP_SUCCESS,
        })
        onSuccess()

        !Array.isArray(res?.message) && successToast(res?.message)
      },
      (err) => {
        dispatch({
          type: SME_CREATE_EXAM_QP.SME_CREATE_EXAM_QP_ERROR,
        })
        showErrorToastMessage(
          !Array.isArray(err?.message) ? err?.message : 'Something went wrong'
        )
        err?.message?.publish_exam?.[0] &&
          showErrorToastMessage(err?.message?.publish_exam?.[0])
        onError()
      },
      payload,
      METHOD.PUT,
      { showToast: false }
    )
  }

// ************** Exam Scheduling and Assignment ******************

export const assignExam =
  (
    examId: number,
    payload: Record<string, any>,
    onSuccess: () => void,
    onError?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ASSIGN_EXAM.ASSIGN_EXAM_INITLIZATION,
    })
    apiCall(
      `${EXAM_LIST_URL}/${examId}/assign_exam`,
      () => {
        dispatch({
          type: ASSIGN_EXAM.ASSIGN_EXAM_SUCCESS,
        })
        successToast('Exam assigned successfully')
        onSuccess()
      },
      (err) => {
        dispatch({
          type: ASSIGN_EXAM.ASSIGN_EXAM_ERROR,
        })
        err?.message?.exam?.[0] &&
          showErrorToastMessage(err?.message?.exam?.[0])
        onError && onError()
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

// ************** STUDENT LIST FROM EXAM DOWNLOAD EXCEL ******************

export const studentDataDownloadExcel =
  (
    showToast: boolean,
    id: string | undefined,
    search: string | null,
    ordering: Record<string, string> | null,
    attempt_status: string | null,
    sorted: any,
    handleSuccess?: (...args) => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    const params = new URLSearchParams()
    params.append('all_sorted_records', sorted)
    ordering &&
      ordering.student_firstname &&
      params.append('ordering', ordering.student_firstname)
    ordering && ordering.rank && params.append('ordering', ordering.rank)
    params.append('subject_performace', 'true')
    dispatch({
      type: STUDENT_DATA_DOWNLOAD_EXCEL.STUDENT_DATA_DOWNLOAD_EXCEL_INITIALIZATION,
    })
    apiCall(
      STUDENT_LIST_URL + `${id}/report`,
      (res: any) => {
        dispatch({
          type: STUDENT_DATA_DOWNLOAD_EXCEL.STUDENT_DATA_DOWNLOAD_EXCEL_SUCCESS,
          payload: res.data,
        })
        handleSuccess && handleSuccess(res.data)
      },
      (err: any) => {
        dispatch({
          type: STUDENT_DATA_DOWNLOAD_EXCEL.STUDENT_DATA_DOWNLOAD_EXCEL_ERROR,
          payload: err.message,
        })
      },
      {
        params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

// ************** STUDENT LIST FROM EXAM DOWNLOAD EXCEL QUESTION WISE ******************

export const studentDataDownloadExcelQuestionWise =
  (
    showToast: boolean,
    id: string | undefined,
    handleSuccess?: (...args) => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    const params = new URLSearchParams()
    dispatch({
      type: STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL.STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_INITIALIZATION,
    })
    apiCall(
      QUESTION_WISE_STUDENT_LIST_URL + `${id}/question-wise-student-report`,
      (res: any) => {
        dispatch({
          type: STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL.STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_SUCCESS,
          payload: res.data,
        })
        handleSuccess && handleSuccess(res.data)
      },
      (err: any) => {
        dispatch({
          type: STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL.STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_ERROR,
          payload: err.message,
        })
      },
      {
        params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

// ************** Assign View Report Permission to Employee ******************

export const assignViewReportPermission =
  (
    examId: number,
    candidate_list: {
      user_exam_submission: number
      access_report: boolean
    }[],
    handleSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ASSIGN_VIEW_EXAM_REPORT_PERMISSION.GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_INITIALIZATION,
    })
    apiCall(
      ASSIGN_VIEW_REPORT_PERMISSION_URL.replace('examId', examId.toString()),
      (res: any) => {
        dispatch({
          type: ASSIGN_VIEW_EXAM_REPORT_PERMISSION.GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_SUCCESS,
          payload: res.data,
        })
        handleSuccess && handleSuccess()
      },
      () => {
        dispatch({
          type: ASSIGN_VIEW_EXAM_REPORT_PERMISSION.GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_ERROR,
        })
      },
      {
        user_exam_submission_list: candidate_list,
      },
      METHOD.POST,
      { showToast: true }
    )
  }

// ************** Get Exam batch ******************

export const getExamBatch =
  (
    examId: string,

    handleSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_EXAM_BATCH.GET_EXAM_BATCH_INITIALIZATION,
    })
    apiCall(
      GET_EXAM_BATCHES_URL.replace('examId', examId.toString()),
      (res: any) => {
        dispatch({
          type: GET_EXAM_BATCH.GET_EXAM_BATCH_SUCCESS,
          payload: res.data,
        })
        handleSuccess && handleSuccess()
      },
      () => {
        dispatch({
          type: GET_EXAM_BATCH.GET_EXAM_BATCH_FAILED,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
